// lazy-leaflet.js — load Leaflet 1.9.4 from /weather/vendor/ on demand.
// Both fcc-weather and the weatherdog tenant alias `/weather/vendor/` (or
// `/vendor/`) to the shared engine directory, so the URL paths resolve from
// either host.

let _promise = null;

export function loadLeaflet() {
  if (typeof window === 'undefined') return Promise.reject(new Error('no window'));
  if (window.L) return Promise.resolve(window.L);
  if (_promise) return _promise;

  _promise = new Promise((resolve, reject) => {
    // CSS — only inject if not already present on the page.
    if (!document.querySelector('link[href*="leaflet-1.9.4/leaflet.css"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'vendor/leaflet-1.9.4/leaflet.css';
      document.head.appendChild(link);
    }

    // JS — same.
    if (window.L) { resolve(window.L); return; }
    const existing = document.querySelector('script[src*="leaflet-1.9.4/leaflet.js"]');
    if (existing) {
      // Already loading from desktop chrome; wait for it.
      const wait = () => { if (window.L) resolve(window.L); else setTimeout(wait, 50); };
      wait();
      return;
    }
    const s = document.createElement('script');
    s.src = 'vendor/leaflet-1.9.4/leaflet.js';
    s.async = true;
    s.onload = () => { if (window.L) resolve(window.L); else reject(new Error('Leaflet failed to expose window.L')); };
    s.onerror = () => reject(new Error('Leaflet load failed'));
    document.head.appendChild(s);
  });
  return _promise;
}

// IntersectionObserver helper — call onIntersect once when the el enters the
// viewport. Used to defer Leaflet init until the radar/POI section actually
// scrolls into view.
export function whenInView(el, onIntersect, rootMargin = '200px') {
  if (!el || typeof IntersectionObserver === 'undefined') { onIntersect(); return () => {}; }
  let fired = false;
  const obs = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (e.isIntersecting && !fired) { fired = true; obs.disconnect(); onIntersect(); break; }
    }
  }, { rootMargin });
  obs.observe(el);
  return () => obs.disconnect();
}
